"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
// import app components
const dataTable_1 = __importDefault(require("../../combinations/dataTable"));
const Datasets = (props) => {
    const { datasets, onRowClick } = props;
    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleDateString();
    };
    return (react_1.default.createElement(dataTable_1.default, { tabs: [
            { value: "private", label: "My Datasets" },
            { value: "public", label: "Sample Datasets" },
        ], tableHead: [
            { id: "title", name: "Title" },
            { id: "date", name: "Date", format: formatDate, width: 150 },
        ], onRowClick: onRowClick, rows: datasets }));
};
exports.default = Datasets;
